import type { PropsWithChildren } from "react";

export const Italic = ({ children }: PropsWithChildren) => {
	return <em>{children}</em>;
};
